import React, { useState } from 'react';

import { Sheet, SheetContent } from '@epoch-ui/components/Sheet/sheet';
import { SlackReminderForm } from '@event-editor/tabs/EditEventCommunications/components/EditEventCommunicationSideSheet/ReminderForms/SlackReminderForm';
import { EmailReminderForm } from '@event-editor/tabs/EditEventCommunications/components/EditEventCommunicationSideSheet/ReminderForms/EmailReminderForm';
import { SlackReminder } from '@event-editor/api/reminder/slackReminder';
import { EmailReminder } from '@event-editor/api/reminder/emailReminder';
import DiscardConfirmModal from '@epoch-components/DiscardConfirmModal/DiscardConfirmModal';

interface UpdateEventCommunicationSideSheetProps {
  isOpen: boolean;
  onClose: () => void;
  slackReminder?: SlackReminder;
  emailReminder?: EmailReminder;
}
/**
 * Update Event Communication Side Sheet
 * Show the 'update'reminder form based on the medium.
 * @param isOpen
 * @param onClose
 * @param slackReminder
 * @param emailReminder
 * @returns
 */
export const UpdateEventCommunicationSideSheet: React.FC<
  UpdateEventCommunicationSideSheetProps
> = ({ isOpen, onClose, slackReminder, emailReminder }) => {
  const [isFormDirty, setIsFormDirty] = useState(false);
  const [showDiscardModal, setShowDiscardModal] = useState(false);

  const onOpenChange = (open: boolean) => {
    if (!open) {
      // If form is dirty, show discard modal
      if (isFormDirty) {
        setShowDiscardModal(true);
      } else {
        // Otherwise, close normally
        setIsFormDirty(false);
        onClose();
      }
    }
  };

  const handleFormClose = () => {
    setIsFormDirty(false);
    onClose();
  };

  const handleDiscard = () => {
    setShowDiscardModal(false);
    setIsFormDirty(false);
    onClose();
  };

  const handleCancelDiscard = () => {
    setShowDiscardModal(false);
  };

  return (
    <>
      <Sheet open={isOpen} onOpenChange={onOpenChange}>
        <SheetContent
          className="tw-m-2 tw-flex tw-h-[calc(100vh-16px)] tw-w-[480px] tw-flex-col tw-gap-0 tw-rounded-3xl tw-p-0 sm:tw-max-w-[480px]"
          aria-describedby="create-reminder-sheet"
        >
          {/* Show reminder form */}
          {slackReminder ? (
            <SlackReminderForm
              onSuccess={handleFormClose}
              onDirtyChange={setIsFormDirty}
              slackReminder={slackReminder}
            />
          ) : (
            <EmailReminderForm
              onSuccess={handleFormClose}
              onDirtyChange={setIsFormDirty}
              emailReminder={emailReminder!}
            />
          )}
        </SheetContent>
      </Sheet>

      <DiscardConfirmModal
        open={showDiscardModal}
        onOpenChange={setShowDiscardModal}
        onDiscard={handleDiscard}
        onCancel={handleCancelDiscard}
      />
    </>
  );
};
